export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Действия"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактировать информацию об инкассаторе"])}
}